export const permitTypesTableColumns = [
  {
    prop: 'name',
    title: 'common.fields.name',
    width: '12%',
    sortingEnabled: true,
  },
  {
    prop: 'description',
    title: 'common.fields.description',
    width: '46%',
    sortingEnabled: true,
  },
  {
    prop: 'renewal_offset',
    title: 'foreigners.filters.renewal_date',
    width: '8%',
    sortingEnabled: false,
  },
  {
    prop: 'case_assessment',
    title: 'foreigners.filters.case_assessment',
    width: '8%',
    sortingEnabled: true,
  },
  {
    prop: 'documentsCount',
    title: 'adm.permits.types.types_dialog.documents',
    width: '8%',
    sortingEnabled: false,
  },
  {
    prop: 'statusesCount',
    title: 'adm.permits.types.types_dialog.statuses',
    width: '8%',
    sortingEnabled: false,
  },
  {
    prop: 'actions',
    title: 'common.fields.actions',
    width: '10%',
    sortingEnabled: false,
  },
];
